import type { Tone } from "../mappers";
import { DASH } from "../format";
import { toneColor } from "../theme";

export const StatusPill = ({ text, tone }: { text: string; tone: Tone }) => {
  if (text === DASH) return <>{DASH}</>;
  const color = toneColor(tone);
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 700,
        border: `1px solid ${color}`,
        color,
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );
};
